module.exports = __webpack_public_path__ + "img/shoubi.f816a255.jpg";